import FilterButton from "../buttons/FilterButton";
import MarkerAccordion from "../Accordion/MarkerAccordion";
import SearchInput from "../SearchInput";
import { useMapStore } from "../store";

type SideMenu = {
    reportFormUrl: string;
    isMapReady: boolean;
    handleOpenInfowindow: (id: number) => void;
    resetMap: () => void;
}

function SideMenu({ isMapReady, reportFormUrl, handleOpenInfowindow, resetMap }: SideMenu) {
    const { isDesktop } = useMapStore();
    return (
        <div className='divide-y divide-solid divide-white bg-white' style={{height: 600}}>
            <div className={`flex justify-between items-center p-4 gap-2 ${isDesktop ? "bg-ocean" : "bg-grey-50"}`}>
                {isMapReady && <SearchInput placeholder="Search address or suburb" aria-label="Search for an address" />}
                {isDesktop && <div className='mr-2'><FilterButton /></div>}
            </div>
            <div className="w-full bg-slate-200 flex-none" id="map_sidebar">
                <div className='p-4 mt-px bg-ocean'>
                    <p className="h6 text-white mt-6">Outages by suburb:</p>
                </div>
                <div className='overflow-y-scroll' style={{height: isDesktop ? 384: 454}}><MarkerAccordion reportFormUrl={reportFormUrl} handleOpenInfowindow={handleOpenInfowindow} /></div>
            </div>
            {isDesktop && (<button className='w-full px-8 pt-4 pb-8 text-left bg-secondary outline-offset-[-4px] !outline-white' onClick={resetMap}><span className="link-arrow-white">RESET MAP</span></button>)}
        </div>
    )
}

export default SideMenu
